import { AbstractDisplayComponent } from "../../core/displays/AbstractDisplayComponent";
import { SAReels } from "./SAReels";

export class ReelComponent extends AbstractDisplayComponent {
    private container: SAReels;

    public override init() {
        super.init();
        this.container = new SAReels();
    }

    public getInstance(): SAReels {

        return this.container;

    }

    public override destroy(): void {

        this.container.destroy({ children: true });

    }

}

